export default __webpack_public_path__ + "static/pro-1571da166e3b7330b4d3de3f07d39734.webp";